import { HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { cn } from '@/lib/utils'

export type SwipeIconProps = HTMLAttributes<HTMLSpanElement>

const SwipeIcon = ({ className, ...props }: SwipeIconProps) => {
  const root = useRef<HTMLSpanElement>(null)

  useGSAP(
    () => {
      gsap.to('[data-motion-line]', {
        motionPath: {
          fromCurrent: false,
          path: [
            { scaleY: 0, yPercent: -50 },
            { scaleY: 1, yPercent: 0 },
            { scaleY: 0, yPercent: 100 }
          ]
        },
        transformOrigin: 'top center',
        ease: 'power2.inOut',
        duration: 1.5,
        repeat: -1
      })
    },
    {
      scope: root
    }
  )

  return (
    <span
      ref={root}
      className={cn('w-[0.1rem] overflow-hidden bg-surface-primary-dark/30', className)}
      {...props}
    >
      <span
        className="absolute left-0 top-0 h-full w-full bg-surface-primary-dark"
        data-motion-line
      />
    </span>
  )
}

export default SwipeIcon
